import { orchestrator } from "satcheljs";
import { queuedActionDataResult } from "owa-data-worker-client/lib/satchel/completeQueuedActions";
import { logSendDatapointAfterAQ } from "owa-mail-compose-logging/lib/utils/logSendE2EOfflineData";
import { doesItemExistInOutbox } from "../utils/outboxUtils";

orchestrator(queuedActionDataResult, message => {
    const data = message.result.data;
    if (data?.sendItem) {
        const itemId: string | undefined = message.op.variables?.itemId?.Id;
        if (itemId) {
            logSendDatapointAfterAQ(itemId, doesItemExistInOutbox(itemId));
        }
    }
});
